import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AdditionalOrderColumn,
  FilterDefinitionType,
  OrdersTab,
  PayoutCancelStatusDetails,
} from 'enums';
import { useQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const CancelledOrders: React.FC = () => {
  useQueryFilters<OrderFilters>({
    from: moment().subtract(1, 'w').startOf('d').toISOString(),
  });

  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      {
        label: tFilters('cancel_reason'),
        name: 'statusDetails',
        type: FilterDefinitionType.Enum,
        enum: PayoutCancelStatusDetails,
        getDisplayName: orderUtils.getPayoutStatusDetailsLabel,
      },
    ],
    [tFilters],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.Cancelled}
      additionalFilters={additionalFilters}
      additionalColumns={[
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.CancelReason,
        AdditionalOrderColumn.Validation,
        AdditionalOrderColumn.OrderProcessedBy,
        AdditionalOrderColumn.TraderPayment,
      ]}
    />
  );
};
